import instagramSVG from '../img/instagram.svg';
import facebookSVG from '../img/facebook.svg';
import telegramSVG from '../img/telegram.svg';

const socialList = [
  {
    name: 'instagram',
    icon: instagramSVG,
  },
  {
    name: 'facebook',
    icon: facebookSVG,
  },
  {
    name: 'telegram',
    icon: telegramSVG,
  },
];

const socialIcons = {
  telegram: telegramSVG,
  facebook: facebookSVG,
  instagram: instagramSVG,
};

const gameTypes = {
  slots: 'slots',
  liveCasino: 'live-casino',
  crashGames: 'crash-games',
  virtualGames: 'virtual-games',
};

const customGameTypesFilter = [
  {
    name: 'slots',
    value: gameTypes.slots,
    isActive: true,
  },
  {
    name: 'liveCasino',
    value: gameTypes.liveCasino,
    isActive: false,
  },
  {
    name: 'crashGames',
    value: gameTypes.crashGames,
    isActive: false,
  },
  {
    name: 'virtualGames',
    value: gameTypes.virtualGames,
    isActive: false,
  },
];

const customProviderItemsFilter = [
  {
    name: 'Bluejack',
    value: 'bluejack',
    type: gameTypes.slots,
    position: 1,
    isActive: false,
  },
  {
    name: 'Slotegrator',
    value: 'slotegrator',
    type: gameTypes.slots,
    position: 2,
    isActive: false,
  },
  {
    name: 'Pragmatic Slots',
    value: 'pragmatic',
    type: gameTypes.slots,
    position: 3,
    isActive: false,
  },
  {
    name: 'Pragmatic RGS',
    value: 'pragmatic-rgs',
    type: gameTypes.slots,
    position: 93,
    isActive: false,
  },
  {
    name: 'OutCome',
    value: 'outcome',
    type: gameTypes.slots,
    position: 4,
    isActive: false,
  },
  {
    name: 'RubyPlay',
    value: 'rubiplay',
    type: gameTypes.slots,
    position: 5,
    isActive: false,
  },
  {
    name: 'SoftGamingSlots',
    value: 'SoftGamingSlots',
    type: gameTypes.slots,
    position: 6,
    isActive: false,
  },
  {
    name: 'PopOkGaming',
    value: 'popokgaming',
    type: gameTypes.slots,
    position: 7,
    isActive: false,
  },
  {
    name: 'RedRake',
    value: 'redrake',
    type: gameTypes.slots,
    position: 8,
    isActive: false,
  },
  {
    name: 'Belatra',
    value: 'belatra',
    type: gameTypes.slots,
    position: 9,
    isActive: false,
  },
  {
    name: 'Platipus',
    value: 'platipus',
    type: gameTypes.slots,
    position: 10,
    isActive: false,
  },
  {
    name: 'Hacksaw',
    value: 'hacksaw',
    type: gameTypes.slots,
    position: 11,
    isActive: false,
  },
  {
    name: 'Amusnet',
    value: 'amusnet',
    type: gameTypes.slots,
    position: 12,
    isActive: false,
  },
  {
    name: 'AmigoGaming',
    value: 'amigogaming',
    type: gameTypes.slots,
    position: 13,
    isActive: false,
  },
  {
    name: 'Bgaming',
    value: 'bgaming',
    type: gameTypes.slots,
    position: 14,
    isActive: false,
  },
  {
    name: 'Rgs',
    value: 'rgs',
    type: gameTypes.slots,
    position: 15,
    isActive: false,
  },
  {
    name: 'Winfinity',
    value: 'winfinity',
    type: gameTypes.slots,
    position: 16,
    isActive: false,
  },
  {
    name: 'Winfinity Live Casino',
    value: 'winfinityLive',
    type: gameTypes.liveCasino,
    position: 17,
    isActive: false,
  },
  {
    name: 'TvBet',
    value: 'tvBet',
    type: gameTypes.liveCasino,
    position: 18,
    isActive: false,
  },
  {
    name: 'Jacktop',
    value: 'jacktop',
    type: gameTypes.liveCasino,
    position: 19,
    isActive: false,
  },
  {
    name: 'XPG',
    value: 'xpg',
    type: gameTypes.liveCasino,
    position: 20,
    isActive: false,
  },
  {
    name: 'Pragmatic Live',
    value: 'pragmaticlive',
    type: gameTypes.liveCasino,
    position: 21,
    isActive: false,
  },
  {
    name: 'Ezugi',
    value: 'ezugi',
    type: gameTypes.liveCasino,
    position: 22,
    isActive: false,
  },
  {
    name: 'Evolution',
    value: 'evolution',
    type: gameTypes.liveCasino,
    position: 23,
    isActive: false,
  },
  {
    name: 'Vivogaming',
    value: 'vivogaming',
    type: gameTypes.liveCasino,
    position: 24,
    isActive: false,
  },
  {
    name: 'UpGaming',
    value: 'upgaming',
    type: gameTypes.crashGames,
    position: 25,
    isActive: false,
  },
  {
    name: '100hp',
    value: '100hp',
    type: gameTypes.crashGames,
    position: 26,
    isActive: false,
  },
  {
    name: 'GoldenRace',
    value: 'goldenRace',
    type: gameTypes.virtualGames,
    position: 27,
    isActive: false,
  },
  {
    name: 'UniversalRace',
    value: 'universalRace',
    type: gameTypes.virtualGames,
    position: 28,
    isActive: false,
  },
  {
    name: 'Igt',
    value: 'outcome:igt',
    type: gameTypes.slots,
    position: 29,
    isActive: false,
  },
  {
    name: 'Netent',
    value: 'outcome:netent',
    type: gameTypes.slots,
    position: 30,
    isActive: false,
  },
  {
    name: 'Booongo',
    value: 'outcome:booongo',
    type: gameTypes.slots,
    position: 31,
    isActive: false,
  },
  {
    name: 'Playson',
    value: 'outcome:playson',
    type: gameTypes.slots,
    position: 32,
    isActive: false,
  },
  {
    name: 'Playngo',
    value: 'outcome:playngo',
    type: gameTypes.slots,
    position: 33,
    isActive: false,
  },
  {
    name: 'Amatic',
    value: 'outcome:amatic',
    type: gameTypes.slots,
    position: 34,
    isActive: false,
  },
  {
    name: 'Microgaming',
    value: 'outcome:microgaming',
    type: gameTypes.slots,
    position: 35,
    isActive: false,
  },
  {
    name: 'Aristocrat',
    value: 'outcome:aristocrat',
    type: gameTypes.slots,
    position: 36,
    isActive: false,
  },
  {
    name: 'Aviatrix',
    value: 'outcome:aviatrix',
    type: gameTypes.slots,
    position: 37,
    isActive: false,
  },
  {
    name: 'Inout',
    value: 'outcome:inout',
    type: gameTypes.slots,
    position: 38,
    isActive: false,
  },
  {
    name: 'Pushgaming',
    value: 'outcome:pushgaming',
    type: gameTypes.slots,
    position: 39,
    isActive: false,
  },
  {
    name: 'Nolimit',
    value: 'outcome:nolimit',
    type: gameTypes.slots,
    position: 40,
    isActive: false,
  },
  {
    name: 'Greentube',
    value: 'outcome:greentube',
    type: gameTypes.slots,
    position: 41,
    isActive: false,
  },
  {
    name: 'Playtech',
    value: 'outcome:playtech',
    type: gameTypes.slots,
    position: 42,
    isActive: false,
  },
  {
    name: 'Wmg',
    value: 'outcome:wmg',
    type: gameTypes.slots,
    position: 43,
    isActive: false,
  },
  {
    name: 'Relaxgaming',
    value: 'outcome:relaxgaming',
    type: gameTypes.slots,
    position: 44,
    isActive: false,
  },
  {
    name: 'Quickspin',
    value: 'outcome:quickspin',
    type: gameTypes.slots,
    position: 45,
    isActive: false,
  },
  {
    name: 'Spribe',
    value: 'outcome:spribe',
    type: gameTypes.slots,
    position: 46,
    isActive: false,
  },
  {
    name: 'Merkur',
    value: 'outcome:merkur',
    type: gameTypes.slots,
    position: 47,
    isActive: false,
  },
  {
    name: 'Elbet',
    value: 'outcome:elbet',
    type: gameTypes.slots,
    position: 48,
    isActive: false,
  },
  {
    name: 'Betsoft',
    value: 'outcome:betsoft',
    type: gameTypes.slots,
    position: 49,
    isActive: false,
  },
  {
    name: 'Igrosoft',
    value: 'outcome:igrosoft',
    type: gameTypes.slots,
    position: 50,
    isActive: false,
  },
  {
    name: 'Gaminator',
    value: 'outcome:gaminator',
    type: gameTypes.slots,
    position: 51,
    isActive: false,
  },
  {
    name: 'Wazdan',
    value: 'outcome:wazdan',
    type: gameTypes.slots,
    position: 52,
    isActive: false,
  },
  {
    name: 'Apollo',
    value: 'outcome:apollo',
    type: gameTypes.slots,
    position: 53,
    isActive: false,
  },
  {
    name: 'Kajot',
    value: 'outcome:kajot',
    type: gameTypes.slots,
    position: 54,
    isActive: false,
  },
  {
    name: 'Konami',
    value: 'outcome:konami',
    type: gameTypes.slots,
    position: 55,
    isActive: false,
  },
  {
    name: 'Austria',
    value: 'outcome:austria',
    type: gameTypes.slots,
    position: 56,
    isActive: false,
  },
  {
    name: 'Ssg',
    value: 'outcome:ssg',
    type: gameTypes.slots,
    position: 57,
    isActive: false,
  },
  {
    name: 'Pgsoft',
    value: 'outcome:pgsoft',
    type: gameTypes.slots,
    position: 58,
    isActive: false,
  },
  {
    name: 'BetOnGames',
    value: 'betongames',
    type: gameTypes.slots,
    position: 59,
    isActive: false,
  },
  {
    name: '1spin4win',
    value: 'outcome:1spin4win',
    type: gameTypes.slots,
    position: 60,
    isActive: false,
  },
  {
    name: '3Oaks',
    value: 'outcome:3oaks',
    type: gameTypes.slots,
    position: 61,
    isActive: false,
  },
  {
    name: 'Blueprint',
    value: 'outcome:blueprint',
    type: gameTypes.slots,
    position: 62,
    isActive: false,
  },
  {
    name: 'Spinomenal',
    value: 'outcome:spinometal',
    type: gameTypes.slots,
    position: 63,
    isActive: false,
  },
  {
    name: 'Endorphina',
    value: 'slotegrator:endorphina',
    type: gameTypes.slots,
    position: 64,
    isActive: false,
  },
  {
    name: 'DLV',
    value: 'slotegrator:dlv',
    type: gameTypes.slots,
    position: 65,
    isActive: false,
  },
  {
    name: 'PGSoftOriginal',
    value: 'pgsoftoriginal',
    type: gameTypes.slots,
    position: 66,
    isActive: false,
  },
  {
    name: 'Galaxsys',
    value: 'galaxsys:slots',
    type: gameTypes.slots,
    position: 67,
    isActive: false,
  },
  {
    name: 'Mascot',
    value: 'mascot',
    type: gameTypes.slots,
    position: 68,
    isActive: false,
  },
  {
    name: 'KAgaming',
    value: 'kagaming',
    type: gameTypes.slots,
    position: 69,
    isActive: false,
  },
  {
    name: '100hp',
    value: '100hp:slots',
    type: gameTypes.slots,
    position: 70,
    isActive: false,
  },
  {
    name: 'UpGaming',
    value: 'upgaming:slots',
    type: gameTypes.slots,
    position: 71,
    isActive: false,
  },
  {
    name: 'Amusnet',
    value: 'amusnet:slots',
    type: gameTypes.slots,
    position: 72,
    isActive: false,
  },
  {
    name: 'PopOkGaming',
    value: 'popokgaming:slots',
    type: gameTypes.slots,
    position: 73,
    isActive: false,
  },
  {
    name: 'Winspinity',
    value: 'winfinity:winspinity',
    type: gameTypes.slots,
    position: 74,
    isActive: false,
  },
  {
    name: 'The Hood',
    value: 'winfinity:the-hood',
    type: gameTypes.slots,
    position: 75,
    isActive: false,
  },
  {
    name: 'Winfinity Live Casino',
    value: 'winfinitylivecasino',
    type: gameTypes.liveCasino,
    position: 76,
    isActive: false,
  },
  {
    name: 'Amusnet',
    value: 'amusnet:live-casino',
    type: gameTypes.liveCasino,
    position: 77,
    isActive: false,
  },
  {
    name: 'Pragmatic Live',
    value: 'pragmaticlive:live-casino',
    type: gameTypes.liveCasino,
    position: 78,
    isActive: false,
  },
  {
    name: 'TvBet',
    value: 'tvBet:live-casino',
    type: gameTypes.liveCasino,
    position: 79,
    isActive: false,
  },
  {
    name: 'UpGaming',
    value: 'upgaming:live-casino',
    type: gameTypes.liveCasino,
    position: 80,
    isActive: false,
  },
  {
    name: 'PopOkGaming',
    value: 'popokgaming:live-casino',
    type: gameTypes.liveCasino,
    position: 81,
    isActive: false,
  },
  {
    name: 'El Casino',
    value: 'elcasino',
    type: gameTypes.liveCasino,
    position: 82,
    isActive: false,
  },
  {
    name: '100hp',
    value: '100hp:crash',
    type: gameTypes.crashGames,
    position: 83,
    isActive: false,
  },
  {
    name: 'Galaxsys',
    value: 'galaxsys:crash',
    type: gameTypes.crashGames,
    position: 84,
    isActive: false,
  },
  {
    name: 'Pragmatic Live',
    value: 'pragmaticlive:crash',
    type: gameTypes.crashGames,
    position: 85,
    isActive: false,
  },
  {
    name: 'TvBet',
    value: 'tvBet:crash',
    type: gameTypes.crashGames,
    position: 86,
    isActive: false,
  },
  {
    name: 'UpGaming',
    value: 'upgaming:crash',
    type: gameTypes.crashGames,
    position: 87,
    isActive: false,
  },
  {
    name: 'PopOkGaming',
    value: 'popokgaming:crash',
    type: gameTypes.crashGames,
    position: 88,
    isActive: false,
  },
  {
    name: 'Hacksaw',
    value: 'hacksaw:live-casino',
    type: gameTypes.liveCasino,
    position: 89,
    isActive: false,
  },
  {
    name: 'Bgaming',
    value: 'bgaming:crash',
    type: gameTypes.crashGames,
    position: 90,
    isActive: false,
  },
  {
    name: 'Jacktop',
    value: 'jacktop:crash',
    type: gameTypes.crashGames,
    position: 91,
    isActive: false,
  },
  {
    name: 'Egt',
    value: 'outcome:egt',
    type: gameTypes.slots,
    position: 92,
    isActive: false,
  },
  {
    name: 'Inout',
    value: 'inout:crash',
    type: gameTypes.crashGames,
    position: 93,
    isActive: false,
  },
  {
    name: 'Spribe',
    value: 'spribe:crash',
    type: gameTypes.crashGames,
    position: 94,
    isActive: false,
  },
  {
    name: 'Elbet',
    value: 'elbet:crash',
    type: gameTypes.crashGames,
    position: 95,
    isActive: false,
  },
  {
    name: 'Ssg',
    value: 'ssg:crash',
    type: gameTypes.crashGames,
    position: 96,
    isActive: false,
  },
];

const customTableHeaders = [
  'requestType',
  'agentId',
  'username',
  'agentStructure',
  'lastMonthNetwin',
  'requestDate',
  'details',
  'status',
  'result',
];

export { customTableHeaders, customGameTypesFilter, customProviderItemsFilter, gameTypes, socialList, socialIcons };
